import { render, staticRenderFns } from "./PayrollPaymentAutomatically.vue?vue&type=template&id=00bd2e7e"
import script from "./PayrollPaymentAutomatically.vue?vue&type=script&lang=js"
export * from "./PayrollPaymentAutomatically.vue?vue&type=script&lang=js"
import style0 from "./PayrollPaymentAutomatically.vue?vue&type=style&index=0&id=00bd2e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports